import React, { useState, useEffect } from 'react';
import { formatLokasyonEksik } from '../utils/siparisOneri';

export default function SiparisOneriWidget({ user }) {
  const [onerileri, setOnerileri] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [sonuc, setSonuc] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8001';

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const token = localStorage.getItem('access_token');
    fetch(`${apiUrl}/api/stok/siparis-onerileri`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then(r => (r.ok ? r.json() : []))
      .then(data => {
        if (cancelled) return;
        setOnerileri(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [user, apiUrl]);

  const toggleAll = () => {
    if (selected.size === onerileri.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(onerileri.map(o => o.malzeme_id)));
    }
  };

  const toggleOne = (malzeme_id) => {
    const s = new Set(selected);
    if (s.has(malzeme_id)) s.delete(malzeme_id);
    else s.add(malzeme_id);
    setSelected(s);
  };

  const handleTalepOlustur = async () => {
    const kalemler = onerileri
      .filter(o => selected.has(o.malzeme_id))
      .map(o => ({
        malzeme_id: o.malzeme_id,
        miktar: o.onerilen_miktar,
        tedarikci_id: o.son_tedarikci_id ?? null,
        lokasyon_id: user?.lokasyon_id ?? null,
        aciklama: o.son_tedarikci_ad
          ? `Otomatik sipariş önerisi — Önerilen tedarikçi: ${o.son_tedarikci_ad}`
          : 'Otomatik sipariş önerisi',
      }));

    if (!kalemler.length) return;
    setSubmitting(true);
    setSonuc(null);
    try {
      const token = localStorage.getItem('access_token');
      const resp = await fetch(`${apiUrl}/api/stok/siparis-onerileri/talep-olustur`, {
        method: 'POST',
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(kalemler),
      });
      if (!resp.ok) throw new Error('İstek başarısız');
      const result = await resp.json();
      setSonuc(result);
      setOnerileri(prev => prev.filter(o => !selected.has(o.malzeme_id)));
      setSelected(new Set());
      setTimeout(() => setSonuc(null), 5000);
    } catch (err) {
      setSonuc({ olusturulan: 0, hata: String(err.message || err) });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null;
  if (!onerileri.length) return null;

  return (
    <div style={{
      background: '#fff7ed', border: '1px solid #fed7aa',
      borderRadius: 8, padding: 16, marginBottom: 16,
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', marginBottom: 12,
      }}>
        <h3 style={{ margin: 0, fontSize: 15, color: '#92400e' }}>
          ⚠️ {onerileri.length} malzeme kritik stok seviyesinde
        </h3>
        <button
          onClick={toggleAll}
          style={{
            fontSize: 12, padding: '4px 10px',
            border: '1px solid #fb923c', borderRadius: 4,
            background: 'white', cursor: 'pointer', color: '#c2410c',
          }}
        >
          {selected.size === onerileri.length ? 'Seçimi Kaldır' : 'Tümünü Seç'}
        </button>
      </div>

      <div style={{ maxHeight: 320, overflowY: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #fed7aa', color: '#78350f' }}>
              <th style={{ textAlign: 'left', padding: '4px 8px', width: 28 }}></th>
              <th style={{ textAlign: 'left', padding: '4px 8px' }}>Malzeme</th>
              <th style={{ textAlign: 'right', padding: '4px 8px' }}>Stok</th>
              <th style={{ textAlign: 'right', padding: '4px 8px' }}>Min</th>
              <th style={{ textAlign: 'right', padding: '4px 8px' }}>Öneri</th>
              <th
                style={{ textAlign: 'right', padding: '4px 8px' }}
                title="Ağırlıklı ortalama fiyat × öneri — KDV hariç (net)"
              >
                Tahmini ₺
                <span style={{ fontSize: 9, fontWeight: 400, color: '#a16207' }}> (KDV hariç)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {onerileri.map(o => {
              const lokEksik = formatLokasyonEksik(o);
              return (
              <tr key={o.malzeme_id} style={{ borderBottom: '1px solid #fef3c7' }}>
                <td style={{ padding: '4px 8px' }}>
                  <input
                    type="checkbox"
                    checked={selected.has(o.malzeme_id)}
                    onChange={() => toggleOne(o.malzeme_id)}
                    aria-label={`${o.malzeme_ad} talep seç`}
                  />
                </td>
                <td style={{ padding: '4px 8px' }}>
                  <div>{o.malzeme_ad}</div>
                  {lokEksik && (
                    <div
                      style={{ fontSize: 11, color: '#b45309' }}
                      title="Lokasyon bazında eksik — net toplam yeterli görünse de bu lokasyon(lar) kritik"
                    >
                      📍 {lokEksik}
                    </div>
                  )}
                  {o.son_tedarikci_ad && (
                    <div style={{ fontSize: 11, color: '#92400e' }}>→ {o.son_tedarikci_ad}</div>
                  )}
                </td>
                <td style={{ textAlign: 'right', padding: '4px 8px', color: '#dc2626' }}>
                  {o.mevcut_stok} {o.birim}
                </td>
                <td style={{ textAlign: 'right', padding: '4px 8px', color: '#6b7280' }}>
                  {o.min_stok}
                </td>
                <td style={{ textAlign: 'right', padding: '4px 8px', fontWeight: 600 }}>
                  {o.onerilen_miktar} {o.birim}
                  {o.acik_talep > 0 && (
                    <div style={{ fontSize: 10, fontWeight: 400, color: '#92400e' }}>
                      −{o.acik_talep} açık talep düşüldü
                    </div>
                  )}
                </td>
                <td
                  style={{ textAlign: 'right', padding: '4px 8px', color: '#374151' }}
                  title={o.fiyat_kaynak ? `Fiyat kaynağı: ${o.fiyat_kaynak} (KDV hariç)` : undefined}
                >
                  {o.tahmini_tutar
                    ? `₺${o.tahmini_tutar.toLocaleString('tr-TR')}`
                    : '—'}
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {selected.size > 0 && (
        <div style={{
          marginTop: 12, display: 'flex',
          justifyContent: 'flex-end', gap: 8, alignItems: 'center',
        }}>
          <span style={{ fontSize: 13, color: '#78350f' }}>
            {selected.size} ürün seçili
          </span>
          <button
            onClick={handleTalepOlustur}
            disabled={submitting}
            style={{
              background: submitting ? '#9ca3af' : '#ea580c',
              color: 'white', border: 'none',
              borderRadius: 6, padding: '8px 16px',
              cursor: submitting ? 'not-allowed' : 'pointer',
              fontWeight: 600, fontSize: 13,
            }}
          >
            {submitting ? 'Oluşturuluyor...' : `${selected.size} Talep Oluştur`}
          </button>
        </div>
      )}

      {sonuc && (
        <div style={{
          marginTop: 8, padding: '8px 12px',
          background: sonuc.hata ? '#fee2e2' : '#dcfce7',
          color: sonuc.hata ? '#991b1b' : '#166534',
          borderRadius: 4, fontSize: 13,
        }}>
          {sonuc.hata
            ? `⚠️ Hata: ${sonuc.hata}`
            : `✅ ${sonuc.olusturulan} talep oluşturuldu. Talepler sayfasından onaylayabilirsiniz.`}
        </div>
      )}
    </div>
  );
}
